import React from 'react';
import { Form, Select } from 'antd';
import cn from 'classnames';
import { getValueByPath } from '../../../../helpers/getValueByPath';
import styles from './formComponents.module.scss';

const SelectField = ({
  label,
  name,
  getFieldDecorator,
  options = {},
  items = [],
  selectProps,
  valueKey = 'id',
  getContent = (item) => item.name,
  buttonComponent,
  className,
  colon = false,
  ...props
}) => {
  return (
    <Form.Item
      {...props}
      label={label}
      colon={colon}
      className={cn(className, { [styles.removableField]: buttonComponent })}
    >
      {getFieldDecorator(
        name,
        options
      )(
        <Select {...selectProps}>
          {items.map((item) => {
            const value = getValueByPath(item, valueKey);

            return (
              <Select.Option key={value} value={value}>
                {getContent(item)}
              </Select.Option>
            );
          })}
        </Select>
      )}
      {buttonComponent}
    </Form.Item>
  );
};

export default SelectField;
